import { videoWatermarkPreset } from './videoWatermarks';
import { useLayoutEffect, useRef, useState, type CSSProperties } from 'react';
import type { VideoWatermark } from './videoComposition';

export function VideoWatermarkOverlay({ watermark, visible }: { watermark: VideoWatermark; visible: boolean }) {
  const plane = useRef<HTMLDivElement>(null);
  const [box, setBox] = useState({ width: 0, height: 0 });
  useLayoutEffect(() => {
    const element = plane.current;
    if (!element) return;
    const update = () => { const { width, height } = element.getBoundingClientRect(); const w = Math.min(width, height * 16 / 9); setBox({ width: w, height: w * 9 / 16 }); };
    const observer = new ResizeObserver(update); observer.observe(element); update();
    return () => observer.disconnect();
  }, [visible, watermark.enabled, watermark.asset_url]);
  if (!visible || !watermark.enabled) return null;
  const imageUrl = watermark.kind === 'preset' ? videoWatermarkPreset(watermark.preset_id).imageUrl : watermark.asset_url;
  if (!imageUrl) return null;
  const style: CSSProperties = { width: watermark.size_percent + '%', height: watermark.size_percent + '%', opacity: watermark.opacity };
  if (watermark.position === 'center') Object.assign(style, { left: '50%', top: '50%', transform: 'translate(-50%, -50%)', objectPosition: 'center' });
  else {
    const right = watermark.position.endsWith('right'), bottom = watermark.position.startsWith('bottom');
    Object.assign(style, { [right ? 'right' : 'left']: watermark.margin_px / 1920 * 100 + '%', [bottom ? 'bottom' : 'top']: watermark.margin_px / 1080 * 100 + '%', objectPosition: (right ? 'right' : 'left') + ' ' + (bottom ? 'bottom' : 'top') });
  }
  return <div ref={plane} className="video-watermark-plane"><div className="video-watermark-frame" style={box}><img className="video-watermark-overlay" aria-label="正片水印预览" src={imageUrl} alt="" style={style} /></div></div>;
}
